function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  height: 577,
  maskUnits: "userSpaceOnUse",
  width: 532,
  x: 92,
  y: 55
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m624 55.5053h-531.8587v576.4707h531.8587z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m614.936 492.519c-54.561 131.517-284.325 197.504-400.886 73.649-29.21-31.04-52.053-82.127-68.754-121.626-12.857-30.418-39.567-106.588-44.489-138.638-94.03947-556.141 610.402-45.444 514.129 186.615",
  fill: "#c1d4cd",
  fillRule: "evenodd"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m135.422 77.0151c-18.981-.7181-17.271 24.4369-30.781 35.8739-14.4057 12.191-31.3049 16.736-47.293 26.421-39.0394 23.661-27.9159 89.174-29.6776 127.777-.8553 18.743-10.5193 36.229-11.4536 54.989-2.0291 40.752 10.7866 36.539 13.399 60.762 2.8936 26.83-10.1033 61.059-.3138 86.632 9.1829 23.978 40.7245 35.967 53.138 58.324 16.6621 30.011 11.1817 64.235 41.24 86.81 12.179 9.147 28.135 10.402 40.111 19.652 10.517 8.129 16.07 22.116 22.661 33.205 22.828 38.437 61.752 45.501 104.099 39.796 20.755-2.795 41.173-11.444 61.612-16.062 38.851-8.772 70.469-15.034 69.693-61.272-.149-8.845 1.59-18.925-3.982-26.449-9.34-12.618-25.775-23.635-31.583-38.361-6.547-16.594-.753-36.299-11.468-51.069-12.39-17.082-35.113-25.448-51.043-38.921-17.107-14.463-29.413-35.042-43.312-52.3-16.392-20.359-49.645-29.124-59.264-54.69-21.26-56.498 19.016-79.177 22.533-132.075 2.605-39.195-22.148-31.782-34.596-59.519-23.779-53.002 19.995-95.9988-73.719-99.5239",
  fill: "#f6e8e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m412.843 589.597c-13.337 8.363-47.177 21.729-63.723 17.645-46.175-11.389-65.495-68.8-55.591-110.592 13.356-56.363 52.668-89.179 84.408-135.086 24.351-35.215 48.028-72.629 65.869-111.687 8.424-18.441 15.575-37.971 21.014-57.558 6.203-22.344-4.063-71.149 17.583-83.99 5.953-3.534 23.624-9.9644 30.134-6.168 38.214 22.277 73.448 167.834 76.097 211.903 4.664 77.648-35.461 200.37-106.679 241.473-22.746 13.127-46.746 20.038-69.112 34.06",
  fill: "#e4c06e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m370 515s-76.613 38.301-53.735 58.65c22.882 20.349 53.735-58.65 53.735-58.65",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m450 425s-74.701 35.604-57.4 54.005c17.304 18.401 57.4-54.005 57.4-54.005",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m496 327s-53.088 56.857-33.767 64.441c19.321 7.583 33.767-64.441 33.767-64.441",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m517.634 228s-37.753 61.52-13.515 63.936c24.246 2.415 13.515-63.936 13.515-63.936",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m499 131s4.907 72.049 23.313 65.59c18.401-6.456-23.313-65.59-23.313-65.59",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m412.833.496946c15.114 5.449844 2.736 35.013954-4.488 31.157254-12.015-6.4169-8.421-35.81052 4.488-31.157254",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m370.944 18.5312c17.31-4.5838 14.605 21.9419.598 24.2625-15.797 2.6203-14.781-20.5117-.598-24.2625",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m396.381 48.3756c14.195-3.5818 20.093 19.5203 3.818 23.9363-19.076 5.1815-17.478-20.4896-3.818-23.9363",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m360.224 59.0805c15.779 2.0055 3.594 21.7152-2.123 19.7869-13.139-4.4329-8.737-21.1662 2.123-19.7869",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m329.723 54.3713c3.187 22.3251-22.279 23.2523-19.512 14.4304 1.747-5.5813 18.669-20.3389 19.512-14.4304",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m407.87 87.7544c17.047 8.8968 2.869 30.3876-2.746 26.8576-9.157-5.761-7.886-32.4018 2.746-26.8576",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m371.616 91.0021c15.415-.2792 3.593 27.2199-7.342 30.7559-10.555 3.416-7.583-30.486 7.342-30.7559",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m330.623 87.2126c16.767 5.3553 4.344 23.7834-2.651 20.3684-8.672-4.23-4.843-22.763 2.651-20.3684",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m299.814 90.0021c14.138.2643.505 33.3249-5.966 32.9959-16.871-.859-10.202-33.2977 5.966-32.9959",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m401.219 131.686c17.427 7.78 5.009 42.185-3.812 39.122-15.24-5.284-10.509-45.512 3.812-39.122",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m359.495 139.8c11.174-4.764 12.781 13.081 3.304 18.254-9.505 5.191-17.005-12.412-3.304-18.254",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m322.926 124.159c3.369-.76 6.971 1.35 9.827 3.283 6.781 4.597-3.123 33.424-11.947 35.457-9.518 2.189-28.981-31.715 2.12-38.74",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m284.61 137.296c16.132 4.475 4.622 18.514 1.355 17.667-9.121-2.361-11.489-20.48-1.355-17.667",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m398.25 195.083c6.268-1.569 8.737 19.697.527 19.91-15.842.411-9.754-17.595-.527-19.91",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m370.795 176.008c3.815-.443 7.63 18.767-1.118 18.986-14.79.376-4.68-18.311 1.118-18.986",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m335.936 179.423c4.17 1.124 6.261 6.065 8.676 9.66.778 1.158.194 5.97-.098 7.204-5.19 21.868-32.11-2.88-18.91-14.856 4.233-3.839 1.538-4.379 10.332-2.008",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m291.072 176.51c15.555-4.383 16.166 20.909 6.663 21.467-12.89.758-22.094-17.118-6.663-21.467",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m357.184 217.111c17.41-2.096 22.159 26.284 5.525 27.806-19.315 1.77-25.24-25.433-5.525-27.806",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m385.741 248.291c2.089 4.682-9.027 29.673-13.346 15.306-2.51-8.346 7.539-28.326 13.346-15.306",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m347.949 268.416c4.03-2.121 4.243 4.344 4.904 8.754 2.319 15.449-23.897 1.24-4.904-8.754",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m319.062 229.277c11.88-3.463 20.843 26.573 6.717 30.551-5.311 1.5-19.972-7.119-18.701-13.74 1.35-7.009 5.66-14.969 11.984-16.811",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m288.652 218.29c7.985-5.196 11.931 6.768 4.091 10.029-7.71 3.208-10.719-5.717-4.091-10.029",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m303.313 274.993c10.875-5.753 14.077 15.393 6.684 15.002-9.918-.522-13.056-11.634-6.684-15.002",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m328.838 303.481c12.812-3.977 15.489 17.817 3.322 24.301-4.486 2.389-31.902-15.428-3.322-24.301",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m311.683 344.963c8.984-4.468 11.335 7.783 3.849 12.774-2.702 1.803-17.457-5.999-3.849-12.774",
  fill: "#1e4b4c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.603546 218.974c4.817534 17.349-.835913 57.023-.59608445 66.51.39816245 15.473 3.98162845 38.57 20.00363845 53.465 3.2994 3.06 17.086 11.655 19.9849 13.024 37.3621 19.789 60.828 8.835 74.361-1.088 15.186-11.135 29.501-31.479 35.7-48.323 5.166-14.058 5.129-32.113.631-45.853-.955-2.922-1.67-6.685-2.68-9.315-.326-.863-.429-1.173-.753-2.041-.186-.499-.696-1.77-.78-1.93-1.69-3.307-5.164-8.41-6.785-10.479-12.718-16.185-32.9-16.357-48.5173-15.791-9.0203.327-18.0966 2.236-26.8864 3.906-12.2057 2.308-27.1263 3.452-40.424 3.609-6.1541.072-21.32149-4.302-23.258754-5.694",
  fill: "#e4b9a9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m81.1067 394.133c-3.1381-15.696-24.1607-27.759-12.7356-46.049 7.9276-12.699 29.0685-1.685 33.8629-8.4 8.713-12.212-7.5382-37.31 13.893-43.157 19.037-5.199 20.547 14.456 34.15 19.404 17.49 6.365 16.952-29.004 36.177-22.011 16.736 6.091 10.49 32.756 19.102 44.603 8.194 11.278 20.03 4.347 31.256 8.256 37.824 13.17 4.919 25.382 4.919 47.354 0 18.511 12.455 26.758 1.447 47.211-7.257 13.493-29.629 1.565-41.676 6.084-23.34 8.76-20.953 39.157-54.412 31.282-15.537-3.663-16.542-26.241-32.698-29.834-8.856-1.97-38.5038 6.479-41.679-7.822-2.9526-13.293 11.8611-29.562 8.3937-46.921",
  fill: "#f9faf5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m166 388.999c0 6.628-5.373 12.001-12.001 12.001s-11.999-5.373-11.999-12.001 5.371-11.999 11.999-11.999 12.001 5.371 12.001 11.999",
  fill: "#516e85"
}));

var SvgGridIcon = function SvgGridIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 709,
    viewBox: "0 0 624 709",
    width: 624,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GridIcon.4d87b627.svg";
export { ForwardRef as ReactComponent };